import * as React from "react";

function ChevronRight(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.657 8L5.333 3.533l.839-.866L11.333 8l-5.161 5.333-.839-.866L9.657 8z"
      />
    </svg>
  );
}

export default ChevronRight;
